class RewardsService {
  constructor(client) {
    this.apiClient = client;
  }

  async getAccessHolderLoyalty(entityID, accessHolderID) {
    return await this.apiClient.get(
      `onepark/${entityID}/access-holders/${accessHolderID}/loyalty`
    );
  }

  async updateRewardGroupAssignment(entityID, accessHolderID, rewardGroupID) {
    return await this.apiClient.put(
      `onepark/${entityID}/access-holders/${accessHolderID}/loyalty/reward-group`,
      { rewardGroupID }
    );
  }

  async getRewardGroups(entityID) {
    return await this.apiClient.get(`onepark/${entityID}/reward-groups`);
  }
}

export default RewardsService;
